import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Modal, TextField, Button } from "@mui/material";
import Fab from "@mui/material/Fab";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import { useQuantityContext } from "../QuantityContext";
import LockIcon from "@mui/icons-material/Lock";

function Folders() {
  const [folders, setFolders] = useState([]);
  const [newFolderModal, setNewFolderModal] = useState(false);
  const [imgPreview, setImagePreview] = useState(null);
  const { openSnackbar } = useQuantityContext();
  const [newFolderData, setNewFolderData] = useState({
    name: "",
    pin: "",
    img: "",
    description: "",
  });
  const [errors, setErrors] = useState({});

  const validateForm = () => {
    let tempErrors = {};
    tempErrors.name = newFolderData.name ? "" : "Name is required.";
    tempErrors.pin = newFolderData.pin ? "" : "PIN is required.";
    tempErrors.img = newFolderData.img ? "" : "Image is required.";
    tempErrors.description = newFolderData.description
      ? ""
      : "Description is required.";
    setErrors(tempErrors);
    return Object.values(tempErrors).every((x) => x === "");
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewFolderData({ ...newFolderData, [name]: value });
  };

  const handleInputChangePin = (e) => {
    const { name, value } = e.target;
    if (name === "pin" && !/^\d*$/.test(value)) return; // Allow only digits
    setNewFolderData((prev) => ({ ...prev, [name]: value }));
  };


  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setNewFolderData({ ...newFolderData, img: file });
      setImagePreview(URL.createObjectURL(file));
    }
  };

  const getFolders = async () => {
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/folders`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("objectId")}`,
        },
      }
    );

    const data = await response.json();
    setFolders(data.data.folders);
  };

  const handleAddNote = async () => {
    if (validateForm()) {
      console.log("Form is valid");
      const formData = new FormData();
      formData.append("name", newFolderData.name);
      formData.append("pin", newFolderData.pin);
      formData.append("description", newFolderData.description);
      if (newFolderData.img) {
        formData.append("profile_pic", newFolderData.img);
      }
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/folders`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("objectId")}`,
          },
          body: formData
        }
      );

      const data = await response.json();
      if (data.statusCode === 201) {
        openSnackbar("Folder added successfully", "success");
        getFolders();
        setNewFolderModal(false);
        setNewFolderData({ name: "", pin: "", img: "", description: "" });
        setImagePreview(null);
      } else {
        openSnackbar("Something went wrong", "error");
      }
    }
  };

  // Delete function to handle folder deletion
  const handleFolderDelete = (deletedFolderId) => {
    setFolders(prevFolders => prevFolders.filter(folder => folder.id !== deletedFolderId));
  };

  useEffect(() => {
    getFolders();
  }, []);

  return (
    <div
      className="d-flex align-items-start gap-4 p-4 home-page-container"
      style={{
        minHeight: "100vh",
      }}
    >
      <div
        style={{
          minWidth: "90vw",
          minHeight: "100vh",
          backgroundColor: "white",
          padding: "2rem",
        }}
      >
        <h3 className="fw-semibold">All Secured Folders</h3>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            flexDirection: "row",
            gap: "1rem",
            marginTop: "1rem",
          }}
        >
          {folders && folders.map((folder) => (
            <FolderBox
              key={folder.id}
              folder={folder}
              onDelete={handleFolderDelete}
            />
          ))}
        </div>
      </div>

      <Fab
        color="primary"
        aria-label="add"
        sx={{
          position: "fixed",
          bottom: 50,
          right: 80,
          background: "#ffffff",
          '&:hover': {
            background: "#ffffff", // Set same as normal background to remove hover effect
          },
        }}
        onClick={() => setNewFolderModal(true)}
      >
        <AddIcon style={{ color: "#0044c6" }} />
      </Fab>

      <Modal
        open={newFolderModal}
        onClose={() => {
          setNewFolderModal(false);
          setNewFolderData({ name: "", pin: "", img: "", description: "" });
        }}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "rgba(0,0,0,0.1)",
        }}
      >
        <Box
          className="modal-box-1"
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "1rem",
            width: "40%",
            height: "90%",
            backgroundColor: "white",
            padding: "2rem",
            paddingLeft: "8rem",
            paddingRight: "8rem",
          }}
        >
          <h3 className="pt-2 fw-semibold">Add New Secured Folder</h3>
          <TextField
            label="Secured Folder Name"
            variant="outlined"
            name="name"
            value={newFolderData.name}
            onChange={handleInputChange}
            error={!!errors.name}
            helperText={errors.name}
            style={{ width: "100%" }}
          />
          <TextField
            label="Description"
            variant="outlined"
            name="description"
            value={newFolderData.description}
            onChange={handleInputChange}
            error={!!errors.description}
            helperText={errors.description}
            style={{ width: "100%" }}
          />

          <TextField
            label="PIN"
            variant="outlined"
            name="pin"
            // type="number"
            value={newFolderData.pin}
            onChange={handleInputChangePin}
            error={!!errors.pin}
            helperText={errors.pin}
            style={{ width: "100%" }}
          // inputProps={{
          //   inputMode: "numeric",
          //   pattern: "[0-9]*",

          //   // maxLength: 4, // optional, if your PIN has a specific length
          // }}
          />

          {imgPreview && (
            <img
              src={imgPreview}
              alt="Selected"
              style={{
                width: "60%", height: "60%", marginTop: "8px", border: "1px dashed gray",
                borderRadius: "4px", padding: "15px"
              }}
            />
          )}
          <Button
            variant="contained"
            component="label"
            sx={{ width: "100%", background: "#0044c6", '&:hover': {
              backgroundColor: '#0044c6', // or same as default bg
              boxShadow: 'none',
            }, }}
          >
            Upload Image
            <input
              type="file"
              name="img"
              onChange={handleFileChange}
              style={{ display: "none" }}
            />
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleAddNote}
            sx={{  '&:hover': {
              backgroundColor: '#0044c6', // or same as default bg
              boxShadow: 'none',
            },width: "100%", background: "#0044c6", color: "white" }}
            disabled={!imgPreview}
          >
            Add Folder
          </Button>
        </Box>
      </Modal>
    </div>
  );
}

export default Folders;

const generateRandomRgba = () => {
  const r = Math.floor(Math.random() * 256);
  const g = Math.floor(Math.random() * 256);
  const b = Math.floor(Math.random() * 256);
  return `rgba(${r}, ${g}, ${b}, 0.3)`;
};

const FolderBox = ({ folder, onDelete }) => {
  const [type, setType] = useState("");
  const [folder_id, setFolderId] = useState("");
  const [password, setPassword] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [otpModal, setOtpModal] = useState(false);
  const [imgError, setImgError] = useState(false);
  const [bgColor] = useState(generateRandomRgba());
  const [isHovered, setIsHovered] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteOtpModal, setDeleteOtpModal] = useState(false);
  const [deletePassword, setDeletePassword] = useState("");
  const [deleteType, setDeleteType] = useState("");

  const { openSnackbar } = useQuantityContext();
  const navigate = useNavigate();

  const handleDeleteClick = (e) => {
    e.stopPropagation();
    setShowDeleteModal(true);
  };

  const handleInputChangeVerify = (e) => {
    const { name, value } = e.target;
    if (!/^\d*$/.test(value)) return; // Allow only digits

    setPassword(value);

  };
  const cancelDelete = () => {
    setShowDeleteModal(false);
    setDeletePassword("");
    setDeleteType("");
  };

  const sendDeleteOtp = async (type) => {
    setDeleteType(type);
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/v1/folders/otp?type=${type}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("objectId")}`,
        },
      }
    );
    const data = await response.json();

    if (data.statusCode === 200) {
      openSnackbar("OTP sent successfully", "success");
    }
    setShowDeleteModal(false);
    setDeleteOtpModal(true);
  };

  const verifyDeleteCredentials = async () => {
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/v1/folders/otp`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("objectId")}`,
        },
        body: JSON.stringify({
          method: deleteType,
          folder_id: folder.id,
          pin: Number(deletePassword),
        }),
      }
    );

    const data = await response.json();

    if (data.statusCode === 200) {
      // Credentials verified, now delete the folder
      deleteFolder();
    } else {
      openSnackbar("Invalid OTP or PIN", "error");
    }
  };

  const deleteFolder = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/folders/${folder.id}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("objectId")}`,
          },
        }
      );

      const data = await response.json();

      if (data.statusCode === 200) {
        openSnackbar("Folder deleted successfully", "success");
        setDeleteOtpModal(false);
        setShowDeleteModal(false);
        setDeletePassword("");
        setDeleteType("");
        if (onDelete) {
          onDelete(folder.id);
        }
      } else {
        openSnackbar(data.message || "Failed to delete folder", "error");
      }
    } catch (error) {
      openSnackbar("Error deleting folder", "error");
    }
  };

  const sendOtp = async (type) => {
    setType(type);
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/v1/folders/otp?type=${type}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("objectId")}`,
        },
      }
    );
    const data = await response.json();

    if (data.statusCode === 200) {
      openSnackbar("OTP sent successfully", "success");
    }
    setShowModal(false);
    setOtpModal(true);
  };

  const handleVerify = async () => {
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/v1/folders/otp`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("objectId")}`,
        },
        body: JSON.stringify({
          method: type,
          folder_id: folder_id,
          pin: Number(password),
        }),
      }
    );

    const data = await response.json();

    if (data.statusCode === 200) {
      setOtpModal(false);
      setShowModal(false);
      setPassword("");
      navigate(`/notes/${folder_id}`);
      openSnackbar("Folder unlocked successfully", "success");
    } else {
      openSnackbar("Invalid OTP or PIN", "error");
    }
  };

  const handleFolderClick = (id) => {
    setFolderId(id);
    setShowModal(true);
  };

  return (
    <>
      <div
        className="person-box"
        style={{
          textAlign: "left",
          height: "144px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          backgroundColor: bgColor,
          position: "relative",
          cursor: "pointer",
        }}
        onClick={() => handleFolderClick(folder.id)}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          {!imgError && (
            <img
              src={folder.img}
              style={{
                width: "24px",
                height: "24px",
                borderRadius: "50%",
                border: "1px solid #fff",
              }}
              onError={() => setImgError(true)}
            />
          )}
          <LockIcon
            style={{
              width: "20px",
              height: "20px",
            }}
          />
        </div>

        {/* Delete Icon - Only visible on hover */}
        {isHovered && (
          <div
            style={{
              position: "absolute",
              top: "8px",
              right: "8px",
              cursor: "pointer",
              backgroundColor: "rgba(255, 255, 255, 0.9)",
              borderRadius: "50%",
              padding: "4px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              transition: "all 0.2s ease",
            }}
            onClick={handleDeleteClick}
          >
            <DeleteIcon
              style={{
                width: "16px",
                height: "16px",
                color: "#f44336",
              }}
            />
          </div>
        )}

        <p
          style={{
            margin: "0",
            padding: "0",
            fontWeight: "900",
          }}
        >
          {folder.name}
          <span
            style={{
              display: "block",
              fontSize: "11px",
              fontWeight: "200",
            }}
          >
            {folder.description}
          </span>
        </p>
      </div>

      {/* Original Access Modal */}
      <Modal
        open={showModal}
        onClose={() => {
          setShowModal(false);
        }}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "rgba(0,0,0,0.1)",
        }}
      >
        <Box
          className="modal-box-1 py-4 px-4"
          style={{
            backgroundColor: "white",
          }}
        >

          <p className="fw-semibold">Choose the option below to access your secured notes.</p>
          <div className="text-center fw-semibold">
            {folder.name}
          </div>
          <div className="text-center fw-normal pb-3">
            {folder.description}
          </div>

          <Box className="d-flex flex-column justify-content-center align-items-center gap-3">
            <Button
              variant="contained"
              color="primary"
              style={{
                width: "200px",
                background: "#0044c6"
              }}
              onClick={() => sendOtp("phone")}
            >
              Send OTP via phone
            </Button>
            <Button
              variant="contained"
              color="primary"
              style={{
                width: "200px",
                background: "#0044c6"
              }}
              onClick={() => sendOtp("email")}
            >
              Send OTP via email
            </Button>
            <Button
              variant="contained"
              color="primary"
              style={{
                width: "200px",
                background: "#0044c6"
              }}
              onClick={() => {
                setType("pin");
                setOtpModal(true);
                setShowModal(false);

              }}
            >
              Enter PIN
            </Button>
          </Box>

        </Box>
      </Modal>

      {/* Original OTP Modal */}
      <Modal
        open={otpModal}
        onClose={() => {
          setOtpModal(false);
          setShowModal(false);
          setPassword("");
        }}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "rgba(0,0,0,0.3)",
        }}
      >
        <Box
          className="modal-box-1 py-4 px-5"
          style={{
            // display: "flex",
            // flexDirection: "column",
            // justifyContent: "center",
            // alignItems: "center",
            backgroundColor: "white",
          }}
        >
          {(type === "phone" || type === "email") && <p className="fw-semibold text-center px-2">A one-time password has been sent to your phone.<br /> Enter it below to verify your identity.</p>}
          {type === "pin" && <p className="fw-semibold text-center px-2">Please enter your secure PIN to continue. <br />This helps us confirm your identity.</p>}
          <div className="fw-semibold text-center">
            {folder.name}
          </div>
          <p className="text-center">
            {folder.description}
          </p>
          <Box className="d-flex flex-column justify-center-center align-items-center gap-3">

            <TextField
              label={
                type === "phone"
                  ? "Enter OTP"
                  : type === "email"
                    ? "Enter OTP"
                    : "Enter PIN"
              }
              variant="outlined"
              style={{
                width: "200px",
              }}
              value={password}
              // onChange={(e) => setPassword(e.target.value)}
              onChange={(e) => handleInputChangeVerify(e)}
            />
            <Button
              className="py-2"
              variant="contained"
              color="primary"
              style={{
                width: "200px", background: "#0044c6"
              }}
              onClick={handleVerify}
            >
              Submit
            </Button>
          </Box>

        </Box>
      </Modal>

      {/* Delete Confirmation Modal */}
      <Modal
        open={showDeleteModal}
        onClose={cancelDelete}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "rgba(0,0,0,0.5)",
        }}
      >
        <Box
          className="modal-box-1 px-5"
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "1.5rem",
            width: "500px",
            backgroundColor: "white",
            padding: "2rem",
            borderRadius: "8px",
          }}
        >
          <h3
            style={{
              margin: "0",
              padding: "0",
              fontWeight: "600",
              fontSize: "20px",
              color: "#333",
              textAlign: "center",
            }}
          >
            Delete Folder
          </h3>
          <p
            style={{
              margin: "0",
              padding: "0",
              fontWeight: "400",
              color: "#666",
              textAlign: "center",
              lineHeight: "1.5",
            }}
          >
            Are you sure you want to delete this? This action cannot be undone and will delete all notes inside this folder.
          </p>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "1rem",
              width: "100%",
              alignItems: "center",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              style={{
                width: "200px",
                backgroundColor: "#0044c6"
              }}
              onClick={() => sendDeleteOtp("phone")}
            >
              SEND OTP VIA PHONE
            </Button>
            <Button
              variant="contained"
              color="primary"
              style={{
                width: "200px",
                backgroundColor: "#0044c6"
              }}
              onClick={() => sendDeleteOtp("email")}
            >
              SEND OTP VIA EMAIL
            </Button>
            <Button
              variant="contained"
              color="primary"
              style={{
                width: "200px",
                backgroundColor: "#0044c6"
              }}
              onClick={() => {
                setDeleteType("pin");
                setShowDeleteModal(false);
                setDeleteOtpModal(true);
              }}
            >
              Enter PIN
            </Button>
            <Button
              variant="outlined"
              style={{
                width: "200px",
                borderColor: "#0044c6",
                color: "#0044c6",
                marginTop: "1rem",
              }}
              onClick={cancelDelete}
            >
              Cancel
            </Button>
          </div>
        </Box>
      </Modal>

      {/* Delete Verification Modal */}
      <Modal
        open={deleteOtpModal}
        onClose={() => {
          setDeleteOtpModal(false);
          setShowDeleteModal(false);
          setDeletePassword("");
          setDeleteType("");
        }}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "rgba(0,0,0,0.5)",
        }}
      >
        <Box
          className="modal-box-1"
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "1rem",
            width: "400px",
            backgroundColor: "white",
            padding: "2rem",
            borderRadius: "8px",
          }}
        >
          <h3
            style={{
              margin: "0",
              padding: "0",
              fontWeight: "600",
              fontSize: "20px",
              color: "#f44336",
              textAlign: "center",
            }}
          >
            Verify to Delete
          </h3>
          <p
            style={{
              margin: "0",
              padding: "0",
              fontWeight: "400",
              color: "#666",
              textAlign: "center",
            }}
          >
            Enter your {deleteType === "phone" ? "OTP" : deleteType === "email" ? "OTP" : "PIN"} to confirm deletion
          </p>
          <TextField
            label={
              deleteType === "phone"
                ? "Enter OTP"
                : deleteType === "email"
                  ? "Enter OTP"
                  : "Enter PIN"
            }
            variant="outlined"
            style={{
              width: "200px",
            }}
            value={deletePassword}
            onChange={(e) => setDeletePassword(e.target.value)}
          />
          <div
            style={{
              display: "flex",
              gap: "1rem",
              width: "100%",
              justifyContent: "center",
            }}
          >
            <Button
              variant="outlined"
              style={{
                width: "120px",
                borderColor: "#ccc",
                color: "#666",
              }}
              onClick={() => {
                setDeleteOtpModal(false);
                setShowDeleteModal(false);
                setDeletePassword("");
                setDeleteType("");
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              style={{
                width: "120px",
                backgroundColor: "#f44336",
                color: "white",
              }}
              onClick={verifyDeleteCredentials}
            >
              Delete
            </Button>
          </div>
        </Box>
      </Modal>
    </>
  );
};